export class ExternalStyleNames {
  static cta: string = "gvp-cta";
  static ctaBackground: string = "gvp-cta-background";
  static ctaText: string = "gvp-cta-text";
  static ctaButton: string = "gvp-cta-button";
}
